'use client';

import { VariantProps } from 'tailwind-variants';

import { Option } from '@/fo/util/map-product-data';

import { styles } from './UiProductOptionsBase.styles';

type Variants = VariantProps<typeof styles>;

export interface UiProductOptionsBaseProps {
  className?: string;
  options?: Option[];
  size: Variants['size'];
  onOptionClick?: (option: Option) => void;
  /** Максимальное количество опций для отображения на десктопе */
  maxVisible?: number;
  /** Максимальное количество опций для отображения на мобильном устройстве */
  maxVisibleMobile?: number;
  noSelected?: boolean;
}

export function UiProductOptionsBase({
  className,
  options = [],
  size,
  onOptionClick,
  maxVisible,
  maxVisibleMobile = maxVisible,
  noSelected = false
}: UiProductOptionsBaseProps) {
  const slots = styles({ size });

  if (options.length === 0) {
    return null;
  }

  const notVisibleOptions =
    maxVisible !== undefined ? options.length - maxVisible : 0;
  const notVisibleOptionsMobile =
    maxVisibleMobile !== undefined ? options.length - maxVisibleMobile : 0;
  const visibleOptions =
    maxVisible !== undefined ? options.slice(0, maxVisible) : options;

  return (
    <div className={slots.base({ className })}>
      {visibleOptions.map(
        (option, index) =>
          option.label && (
            <div
              key={option.sku}
              className={slots.unit({
                hiddenMobile:
                  maxVisibleMobile !== undefined && index >= maxVisibleMobile,
                inactive: option.stockStatus === 'OUT_OF_STOCK',
                selected: noSelected
                  ? false
                  : option.stockStatus === 'IN_STOCK' && option.isSelected,
                selectedInactive:
                  option.stockStatus === 'OUT_OF_STOCK' && option.isSelected
              })}
              onClick={() => onOptionClick?.(option)}
            >
              {option.label}
            </div>
          )
      )}
      {notVisibleOptions > 0 && (
        <div className={slots.notVisibleOptions()}>+{notVisibleOptions}</div>
      )}
      {notVisibleOptionsMobile > 0 && (
        <div className={slots.notVisibleOptionsMobile()}>
          +{notVisibleOptionsMobile}
        </div>
      )}
    </div>
  );
}
